import { connect } from "react-redux";
import injectIntl from "../../../../../../common/helpers/injectIntl";

import { editTask } from "../../../../../store/plan/actions";
import { post } from "../../../../../actions/general";

import RhytSorting from "./lazy";

export default connect(null, { editTask, post })(injectIntl(RhytSorting as any));